import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import "@blueprintjs/select/lib/css/blueprint-select.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import { App } from "infrastructure/App";
import "mapbox-gl/dist/mapbox-gl.css";
import "normalize.css";
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./in_queue/components/tables/agGrid/NiraAgGrid.scss";
import reportWebVitals from "./reportWebVitals";
import "./sharedStyles/blueprintOverrides.scss";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
